import React from "react";
import {getMessage} from "../util";

export default () => {

    return(<div className="main-frame">
        <h3> {getMessage('default','page_not_found',null)}</h3>
    </div>);
}
